import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { UserAppState } from './types';

export const initialState: UserAppState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsersDefaultPrimaryGroup: (state, action: PayloadAction<string>) => {
      state.usersDefaultPrimaryGroup = action.payload;
    },
  },
});

export const { setUsersDefaultPrimaryGroup } = userSlice.actions;

export const userReducer = userSlice.reducer;
